const ROUTES = {
  AUTH: {
    LOGIN: "/login",
    LOGIN_OTP: "/login/verify-otp",
    FORGOT_PASSWORD: "/forgot-password",
    FORGOT_PASSWORD_OTP: "/forgot-password/verify-otp",
    RESET_PASSWORD: "/reset-password",
  },
  NOT_FOUND: "*",
};

export default ROUTES;
